import { Table, Button, Popconfirm, Space } from 'antd';
import { useUser } from '../../store/userContext';
import { User } from '../../types/user';
import { useTranslation } from "react-i18next";
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { useEffect } from 'react';
import { translatePermissionWithGroup } from '../../utils/permissionTranslator';
import PageNavigation from "../Layout/PageNavigation";

interface UserListProps {
  onEdit: (user: User) => void;
}

const UserList: React.FC<UserListProps> = ({ onEdit }) => {
  const { users, deleteUser, listUsers } = useUser();
  const { t, i18n } = useTranslation();

  useEffect(() => {
    listUsers();
    // eslint-disable-next-line
  }, []);

  const columns = [
    { title: t('name'), dataIndex: 'name' },
    { title: t('email'), dataIndex: 'email' },
    {
      title: t('role'),
      dataIndex: ['roleEntity', 'name'],
    },
    {
      title: t('permissions_'),
      dataIndex: ['roleEntity', 'permissions'],
      render: (permissions: any[]) =>
        permissions?.map(p => translatePermissionWithGroup(p.name, t)).join(', ') || '-',
    },
    {
      title: t('actions'),
      render: (_: any, record: any) => (
        <div
          style={{
            display: 'flex',
            justifyContent: i18n.language === 'ar' || i18n.language === 'ckb'
              ? 'flex-end'
              : 'flex-start',
          }}
        >
          <Space>
            <Button
              type="primary"
              icon={<EditOutlined />}
              onClick={() =>
                onEdit({
                  ...record,
                  role: record.roleEntity?.id || record.roles,
                  permissions: record.roleEntity?.permissions?.map((p: any) => p.id) || [],
                })
              }
            >
              {t('edit')}
            </Button>
            <Popconfirm
              title={t('sure_to_delete') as string}
              onConfirm={() => deleteUser(record.id.toString())}
            >
              <Button type="primary" danger icon={<DeleteOutlined />}>
                {t('delete')}
              </Button>
            </Popconfirm>
          </Space>
        </div>
      ),
    },
  ];

  return (
    <div
      style={{
        overflowX: 'auto',
        direction: i18n.language === 'ar' || i18n.language === 'ckb' ? 'rtl' : 'ltr',
      }}
    >
      <PageNavigation title={t('users') as string} />
      <Table
        rowKey="id"
        columns={columns}
        dataSource={users}
        pagination={{ pageSize: 6 }}
        scroll={{ x: 'max-content' }}
        size="middle"
      />
    </div>
  );
};

export default UserList;
